var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MEDIA_MODEL_FRAGMENT = exports.MEDIA_EXTERNAL_VIDEO_FRAGMENT = exports.MEDIA_VIDEO_FRAGMENT = exports.MEDIA_IMAGE_FRAGMENT = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const imageFragment_1 = require("./imageFragment");
exports.MEDIA_IMAGE_FRAGMENT = (0, graphql_tag_1.default) `
  fragment MediaImageFragment on MediaImage {
    alt
    id
    image {
      ...ImageFragment
    }
  }
  ${imageFragment_1.IMAGE_FRAGMENT}
`;
exports.MEDIA_VIDEO_FRAGMENT = (0, graphql_tag_1.default) `
  fragment MediaVideoFragment on Video {
    alt
    id
    previewImage {
      ...ImageFragment
    }
    sources {
      format
      height
      mimeType
      url
      width
    }
  }
  ${imageFragment_1.IMAGE_FRAGMENT}
`;
exports.MEDIA_EXTERNAL_VIDEO_FRAGMENT = (0, graphql_tag_1.default) `
  fragment MediaExternalVideoFragment on ExternalVideo {
    alt
    embeddedUrl
    id
    previewImage {
      ...ImageFragment
    }
  }
  ${imageFragment_1.IMAGE_FRAGMENT}
`;
exports.MEDIA_MODEL_FRAGMENT = (0, graphql_tag_1.default) `
  fragment MediaModel3dFragment on Model3d {
    alt
    id
    previewImage {
      ...ImageFragment
    }
    sources {
      filesize
      format
      mimeType
      url
    }
  }
  ${imageFragment_1.IMAGE_FRAGMENT}
`;
//# sourceMappingURL=mediaFragment.js.map